import React, { useState } from 'react';
import { FaVideo } from 'react-icons/fa';
import { Link } from 'react-router-dom';

interface VideoUploadProps {
  onFileChange: (file: File | null) => void;
  video?: string | null;
  id: string;
}

const validateVideoSize = (file: File): boolean => {
  const maxSize = 300 * 1024 * 1024; // 300MB en bytes
  if (file.size > maxSize) {
    alert('El video no debe superar los 300MB.');
    return false;
  }
  return true;
};

const VideoUpload: React.FC<VideoUploadProps> = ({
  onFileChange,
  video,
  id,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    console.log(file);
    if (file && file.type === 'video/mp4') {
      if (validateVideoSize(file)) {
        setSelectedFile(file);
        onFileChange(file);
      } else {
        onFileChange(null);
      }
    } else {
      alert('Por favor, selecciona un archivo MP4.');
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files?.[0];
    if (file && file.type === 'video/mp4') {
      if (validateVideoSize(file)) {
        setSelectedFile(file);
        onFileChange(file);
      } else {
        onFileChange(null); // Si el video es demasiado grande, se establece en null
      }
    } else {
      alert('Por favor, arrastra un archivo MP4.');
    }
  };

  const RenderContent = () => {
    if (selectedFile) {
      return (
        <>
          <FaVideo size={60} className="text-red-500" />
          <div className="text-center">
            <p className="text-lg font-semibold text-gray-700">
              {selectedFile.name}
            </p>
          </div>
        </>
      );
    }
    if (video) {
      return (
        <>
          <FaVideo size={60} className="text-red-500" />
          <div className="text-center">
            <Link to={video} target="_blank" className="text-blue-500">
              Ver video
            </Link>
            <p className="text-sm text-gray-500">
              Haz clic para cambiar el video
            </p>
          </div>
        </>
      );
    }
    return (
      <>
        <FaVideo size={60} className="text-gray-500" />
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-700">
            Arrastra y suelta tu video aquí
          </p>
          <p className="text-sm text-gray-500">o haz clic para seleccionar</p>
          <p className="text-xs text-gray-400">Tamaño máximo: 300MB</p>
        </div>
      </>
    );
  };

  return (
    <div
      className="flex flex-col items-center space-y-4"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 w-full bg-white hover:border-blue-500 transition-colors">
        <input
          type="file"
          accept="video/mp4"
          onChange={handleFileChange}
          className="hidden"
          id={id}
        />
        <label
          htmlFor={id}
          className="flex flex-col items-center space-y-4 cursor-pointer"
        >
          <RenderContent />
        </label>
      </div>
    </div>
  );
};

export default VideoUpload;
